import React, { Component } from "react";
import MoneyInput, { cleanValue } from "./../../money-input/MoneyInput";
import { MoneyInput as SparkMoneyInput } from "react-spark";

export const validation = {
  validateOn: ["blur"],
  required: true,
  checkValidity: value => {
    const cleanedValue = cleanValue(value);
    const amount = parseInt(cleanedValue);

    if (!SparkMoneyInput.pattern.test(value)) {
      return {
        isValid: false
      };
    }

    if (amount < 24000) {
      return {
        isValid: false,
        inputAttr: "minlength"
      };
    }

    return {
      isValid: true
    };
  },
  message: {
    default: "Please enter your annual gross income",
    minlength: "Your income is below $24,000"
  }
};

class AnnualGrossIncome extends Component {

  static cleanValue = cleanValue;
  render() {
    return (
      <MoneyInput
        id="annualGrossIncome"
        name="annualGrossIncome"
        label="Personal Annual Income (before taxes)"
        validation={validation}
        value={this.props.value}
        className={this.props.className}
        helper={
          <ul className="sprk-b-List sprk-b-List">
            <li>Please provide only your <strong>personal</strong> annual income (before taxes) that can be verified.</li>
            <li>
              You do not need to include alimony, child support or separate maintenance income unless you want it 
              considered as a basis for repaying the loan.
            </li>
            <li>If you include non-taxable income/benefits, increase the amount by 20%.</li>
          </ul>
        }
      />
    );
  }
}

export default AnnualGrossIncome;
